export default __webpack_public_path__ + "static/media/appsumo_logo.8f4f81e3.svg";